import { render, staticRenderFns } from "./SearchResultPlaceholders.vue?vue&type=template&id=7a4ff614&scoped=true&"
import script from "./SearchResultPlaceholders.vue?vue&type=script&lang=js&"
export * from "./SearchResultPlaceholders.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultPlaceholders.vue?vue&type=style&index=0&id=7a4ff614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ff614",
  null
  
)

export default component.exports